import { render, staticRenderFns } from "./PlacementsSingleStartComponentCard.vue?vue&type=template&id=03fe7ad3&"
import script from "./PlacementsSingleStartComponentCard.vue?vue&type=script&lang=js&"
export * from "./PlacementsSingleStartComponentCard.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsSingleStartComponentCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports